/**
 * Amplitude Feature Flag Experiment 'feature key' constants
 */
export const AmplitudeExperiments = {
    BidIncrementsInBidPanel: 'bid-increments-in-bid-panel',
    ElasticOnCategoryPages: 'sear-641-use-of-elastic-on-category-pages',
    ElasticVsAlgoliaKeywordSearch: 'la_-_elastic_vs_algolia_keyword_search',
    ExposureVsPageViewedCheck: 'exposure-vs-page-viewed-check',
    ImprovedRecommendationsOnEndedLots: 'la_-_improved_recommendations_on_ended_lots',
    ImprovedRecommendationsOnPriceResultsPage: 'la_improved_recommendations_on_price_results_page',
    // new item page layout experiment created 01/20/2025
    LaNewItemPageLayout: 'la-new-item-page-layout',
    NoReservePriceBadge: 'la-display-no-reserve-message',
    PredictiveAverageLotValueInElastic: 'sear-684-predictive-alv-in-elastic',
    PurchaseProtectionBanner: 'laac-976-catalog-page-purchase-protection-banner',
    RemoveZipPaymentInfo: 'laac-865-remove-zip-payment-information',
    SimplifiedCategoryPage: 'simplified-category-page',
    SimplifiedHeader: 'sear-560-simplifiednav-crown',
    VariantJumpingHomePageCheck: 'variant-jumping-home-page-check',
    ZeroResultsSearchPage: 'sear-658-zero-results-search-page-v2',
} as const;

export type AmplitudeExperimentIds = (typeof AmplitudeExperiments)[keyof typeof AmplitudeExperiments];

export const AmplitudeVariants: {
    [key in keyof typeof AmplitudeExperiments]: {
        [variant: string]: string;
        Control: 'control';
        Treatment?: 'treatment';
        TreatmentB?: 'treatmentB';
    };
} = {
    BidIncrementsInBidPanel: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ElasticOnCategoryPages: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ElasticVsAlgoliaKeywordSearch: {
        Control: 'control',
        Off: 'off',
        Treatment: 'treatment',
    },
    ExposureVsPageViewedCheck: {
        Control: 'control',
        Off: 'off',
        Treatment: 'treatment',
    },
    ImprovedRecommendationsOnEndedLots: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ImprovedRecommendationsOnPriceResultsPage: {
        A2oCarousel: 'treatmenta',
        A2oGrid: 'treatmentb',
        Control: 'control',
    },
    LaNewItemPageLayout: {
        Control: 'control',
        Treatment: 'treatment',
    },
    NoReservePriceBadge: {
        Control: 'control',
        Treatment: 'treatment',
    },
    PredictiveAverageLotValueInElastic: {
        AddOnlyMLSignals: 'varianta',
        Control: 'control',
        FullRerank: 'variantb',
        PredictedExpectedValueRerank: 'variantc',
    },
    PurchaseProtectionBanner: {
        Control: 'control',
        Treatment: 'treatment',
    },
    RemoveZipPaymentInfo: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SimplifiedCategoryPage: {
        Control: 'control',
        Treatment: 'treatment',
    },
    SimplifiedHeader: {
        Control: 'control',
        HighContrastBackground: 'treatmenta',
        SearchBarWithBorder: 'treatmentb',
    },
    VariantJumpingHomePageCheck: {
        Control: 'control',
        Treatment: 'treatment',
    },
    ZeroResultsSearchPage: {
        Control: 'control',
        ZeroResultsWithFuzzyMatch: 'treatmenta',
        ZeroResultsWithNoFuzzyMatch: 'treatmentb',
    },
} as const;

export type AmplitudeExperimentsVariantIds = (typeof AmplitudeVariants)[keyof typeof AmplitudeVariants];
